import { button } from "@/helper/locale/base/base_button.en"
import base_otp from "@/helper/locale/base/base_otp.en"
import { date } from "@/helper/locale/base/base_date.en"

export default {
    base_button: button,
    base_otp,
    base_date: date,

    paywithpoint: {
        avaliable_points: 'Avaliable Points',
        can_redeem: 'You can redeem up to ',
        create_voucher: 'Create my discount code',
        minimum_point: 'Please fill in points at least {0} points',
        minimum_bath: 'Please fill in points at least {0} THB',
        points_amount: 'Enter voucher amount',
        point: 'Points',
        code_value: 'Value',
        baht: 'THB',
        switch_unit: 'switch unit',
        create_btn: 'Create NOW!',
        terms_conditions: 'Terms & Conditions',
        inputLbl: {
            name: 'Points',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        inputLblBaht: {
            name: 'THB',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        
    },
    err: {
        err_min_point: "Please fill in points at least {0} points",
        err_min_baht: "Please fill in points at least {0} THB.",
        err_max_point: "Your quota is {0} points ",
        err_max_baht: "Your quota is {0} THB per time.",
        err_limit_peruser: "Sorry, you've exceeded the quota.",
        err_limit_soldout: "Sorry, The quota is exceeded.",
        err_limit_user_point: "Your quota left {0} points, The quota is nearly exceede the limit.",
        err_limit_user_baht: "Your quota left {0} THB, The quota is nearly exceede the limit.",
        err_limit_app_point: "Your quota left {0} points, The quota is nearly exceede the limit.",
        err_limit_app_baht: "Your quota left {0} THB, The quota is nearly exceede the limit."
    },

    confirm_popup: {
        confirm_create:'Confirm to Create ?',
        confirm_detail:'Please tap"Confirm"  to deduct',
        confirm_detail_1:'Points for',
        confirm_detail_2:'THB Discount Code.',
        confirm_warning:'Caution! Please use this code immediately or within limit time.​',
        confirm_btn:'Confirm',
        cancel_btn:'Cancel',
    },

    redeem_success: {
        create_success:'Create Successfully !',
        detail:'Please tap "Use now" button to show the code',
        use_btn:'Use now',

        qr_redeem_success: 'Redeem Successfully !',
        qr_redeem_success_detail: 'You have been redeemed point successfully.',

        qr_redeem_error: 'Redeem Unsuccessfully!',
        qr_redeem_error_detail: 'You have redeemed point unsuccessfully.',

    },

    serial: {
        title: 'Voucher Value',
        baht: 'THB',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        show_code_at_shop: 'Please show this code to the cashier for discount',
        expire_in: 'Expired with in',
        redeem_on: 'Create on {0}',

        condition:'Conditions',
        close_btn: 'Close',

        default_privilege_message: 'As design',
        code_expired: 'This serial has expired.',
    },

    terms_conditions: {
        title: 'Terms & Conditions',
        close: 'Close'
    },

    alert: {
        close_btn: 'Close',
        no_point_title: 'Please fill in points you want to redeem.',
        no_point_msg: 'Please fill in points at least {0} points to create discount code.',

        redeem_title: 'Sorry , the connection error is found.',
        redeem_msg: 'Please try again or come back later in 15 minutes.',

        limit_user_title: "Sorry, you've exceeded the quota.",
        limit_user_msg: 'Please come back again next month.',

        limit_per_user_remaining_title: "Sorry, you're nearly exceeded the quota.",
        limit_per_user_remaining_msg: "Your quota left is {0} points",

        limit_per_app_remaining_title: "The quota is nearly exceeded the limit",
        limit_per_app_remaining_msg: "Your quota left is {0} points",

        limit_app_title: 'Sorry, The quota is exceeded.',
        limit_app_msg: 'Please come back again next month.',

        maximum_user_title: "Sorry, you've reached limit redeem per time.",
        maximum_user_msg: "Your quota is {0} points per time.",

        limit_app_user_title: 'Sorry, The quota is exceeded.',
        limit_app_user_msg: 'Please come back again next month.',

        close_Showcode_msg: 'You can use this Discount code within limit time you can examine your Discount code at Redeemed History menu',
        
        point_not_enought_title: "Your point is not enough",
        point_not_enought_msg: "We're sorry that you cannot redeem this, Please come back later.",
    },

    
    welcome: {
        title: "Create Discount Code by you",
        msg: "Be able to specify your own value discount code with limit time, only redeem when you wish."
    }
}
